import React from "react"
import ThankYou from "../../static/ThankYou/ThankYou"

// todo remove this
const ThankYouPage = (props) => (
  <ThankYou title={`Welcome ${props.firstName}!`} text="Thanks for signing up." />
)

export default ThankYouPage
